import { CircularProgress } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { API_DESCUENTOS_MASIVOS } from '../../../../../shared/services/descuentosMasivos';
import { toast } from 'react-toastify';
import { setErrorMessage } from '../../../../../shared/helpers/functionalities';
import { useSelector } from 'react-redux';

const EmailClientesForm = ({ discount_id, enviadoA = [], handleCancel }) => {
    const paises = useSelector((state) => {
        const { paises } = state;
        return paises;
    });
    const [isLoading, setIsLoading] = useState(false);
    const {
        register,
        handleSubmit,
    } = useForm({
        defaultValues: {
            pais_id: 0,
        },
    });

    const isAlreadySent = (nombre) => enviadoA.includes(nombre);

    const onSubmit = async (data) => {
        try {
            setIsLoading(true);
            const res = await API_DESCUENTOS_MASIVOS.sendEmailClientes({
                ...data,
                discount_id,
            });
            if (res?.success) {
                toast.success(res.message || 'El envío de emails se ha iniciado.');
                handleCancel();
            }
        } catch (error) {
            toast.error(setErrorMessage(error));
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="descuentos-masivos-form">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group flex-grow-1">
                    <label className="mb-1" htmlFor="pais_id">
                        Filtrar por país
                    </label>
                    <select
                        {...register('pais_id')}
                    >
                        <option value={0} disabled={isAlreadySent('Todos')}>
                            Todos {isAlreadySent('Todos') ? '(ya enviado)' : ''}
                        </option>
                        {paises?.map((op) => (
                            <option
                                key={'paises-' + op.id}
                                value={op.id}
                                disabled={isAlreadySent(op.nombre)}
                            >
                                {op.nombre} {isAlreadySent(op.nombre) ? '(ya enviado)' : ''}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="d-flex align-items-center justify-content-end pt-2">
                    <button
                        type="button"
                        className="btn btn-default align-self-end"
                        onClick={handleCancel}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary align-self-end ms-3"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <CircularProgress color="inherit" size={22} />
                        ) : (
                            'Enviar'
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default EmailClientesForm;
